import { useTranslation } from "react-i18next";

const imagePaths = [
  "/images/soutezka.jpg",
  "/images/koupaliste.jpg",
  "/images/pravcicka.jpg",
  "/images/skaly.jpg",
];

const imageGridStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
  gap: "1rem",
};

const imageStyle: React.CSSProperties = {
  width: "100%",
  borderRadius: "8px",
  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  objectFit: "cover",
};

const ThingsToDo = () => {
  const { t } = useTranslation();

  const sections = t("thingsToDo.sections", { returnObjects: true }) as {
    title: string;
    items: { name: string; description: string }[];
  }[];

  return (
    <section id="things-to-do">
      <h2>{t("thingsToDo.title")}</h2>
      <p>{t("thingsToDo.intro")}</p>

      {sections.map((section, i) => (
        <div key={i}>
          <h3>{section.title}</h3>
          <ul>
            {section.items.map((item, j) => (
              <li key={j}>
                <span>
                  <strong>{item.name}: </strong>
                </span>
                <span>{item.description}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}

      <h3>{t("thingsToDo.galleryTitle")}</h3>
      <div style={imageGridStyle}>
        {imagePaths.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Activity ${index + 1}`}
            style={imageStyle}
          />
        ))}
      </div>
    </section>
  );
};

export default ThingsToDo;
